module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image8-65861e105b73ea4247478baa3e4b1ed6.jpg";